import { action, IObservableArray, observable, toJS } from 'mobx';
import api from './api';

export interface Profile {
  id: number;
  name: string;
  baseTemp: number;
  prOffTemp: number;
}

const blankProfile: Omit<Profile, 'id'> = { baseTemp: 20, prOffTemp: 20, name: '' };

export default class ProfilesStore {
  @observable loading = false;
  @observable listProfiles: IObservableArray<Profile> = observable.array([]);
  private listEditingProfiles: Map<number, Profile> = new Map();

  @action.bound public async getProfiles() {
    this.loading = true;
    this.listProfiles = await api.getProfiles();
    this.loading = false;
  }

  @action.bound public addBlankProfile() {
    // @ts-ignore
    this.listProfiles.push(blankProfile);
  }

  @action.bound public removeProfile(item) {
    this.listProfiles.remove(item);
  }

  @action.bound public saveBackupItem(item) {
    this.listEditingProfiles.set(item.id, toJS(item));
  }

  @action.bound public restoreBackedUpItem(item) {
    if (this.listEditingProfiles.has(item.id)) {
      const foundBackup = this.listEditingProfiles.get(item.id) as Profile;
      this.listEditingProfiles.delete(item.id);
      const profile = this.listProfiles.find(profile => profile.id === item.id);
      if (profile) {
        Object.assign(profile, foundBackup);
      }
    }
  }
}
